import { dm_quanhe } from '../models/response/category/dm_quanhe';
import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';

export const QUAN_HE_API_END_POINT = "quan-he";

export const quanHeApi = {
    // Lấy tất cả quan hệ
    selectAll: () => apiGuestClient.get(`${QUAN_HE_API_END_POINT}`),

    // Lấy chi tiết quan hệ theo ID
    detail: (id: number) => apiClient.get(`${QUAN_HE_API_END_POINT}/${id}`),

    // Thêm mới quan hệ
    insert: (data: dm_quanhe) => apiClient.post(`${QUAN_HE_API_END_POINT}`, data),

    // Cập nhật quan hệ
    update: (data: dm_quanhe) => apiClient.put(`${QUAN_HE_API_END_POINT}`, data),

    // Xóa quan hệ
    delete: (id: number) => apiClient.delete(`${QUAN_HE_API_END_POINT}/${id}`),
};
